/**
 * URL par langue.
 *
 * Le français reste à la racine (/pricing) ; les autres langues sont préfixées
 * (/es/pricing). Le préfixe sert de « basename » au routeur React (index.jsx) :
 * les liens internes (/pricing, /articles…) restent écrits sans préfixe et
 * deviennent /es/pricing sur la version espagnole.
 *
 * Seules les pages listées dans config/localizedRoutes.json sont traduites,
 * prérendues et annoncées dans les hreflang. Même liste côté scripts
 * (seo-routes.config.js) : prérendu et sitemap ne peuvent pas diverger.
 */
import config from '../config/localizedRoutes.json';

export const DEFAULT_LANGUAGE = config.defaultLanguage;
export const URL_LANGUAGES = config.urlLanguages;
export const ALL_LANGUAGES = [DEFAULT_LANGUAGE, ...URL_LANGUAGES];

/** Langue portée par l'URL (« es » pour /es/pricing), ou null pour le français. */
export const getUrlLanguage = (pathname = window.location.pathname) => {
  const segment = (pathname.split('/')[1] || '').toLowerCase();
  return URL_LANGUAGES.includes(segment) ? segment : null;
};

/** Basename du routeur : « /es » sur une URL espagnole, « » sinon. */
export const getRouterBasename = () => {
  const lang = getUrlLanguage();
  return lang ? `/${lang}` : '';
};

/** Chemin d'une page dans une langue : localizedPath('/pricing', 'es') → '/es/pricing'. */
export const localizedPath = (path, lang) => {
  const clean = path && path.startsWith('/') ? path : `/${path || ''}`;
  if (!lang || lang === DEFAULT_LANGUAGE) return clean;
  return clean === '/' ? `/${lang}/` : `/${lang}${clean}`;
};

/** La page existe-t-elle dans toutes les langues ? (chemin sans préfixe) */
export const isLocalizedPath = (path) => {
  const clean = (path || '/').replace(/\/+$/, '') || '/';
  if (config.excludedRoutes.includes(clean)) return false;
  return config.routes.some((route) =>
    route.endsWith('/*') ? clean.startsWith(route.slice(0, -1)) : clean === route
  );
};

const OG_LOCALES = {
  fr: 'fr_FR', en: 'en_GB', es: 'es_ES', it: 'it_IT', de: 'de_DE', pt: 'pt_PT', nl: 'nl_NL',
  pl: 'pl_PL', cs: 'cs_CZ', sk: 'sk_SK', da: 'da_DK', sv: 'sv_SE', fi: 'fi_FI', el: 'el_GR',
  hr: 'hr_HR', hu: 'hu_HU', lt: 'lt_LT', ro: 'ro_RO',
};

export const ogLocale = (lang) => OG_LOCALES[lang] || OG_LOCALES[DEFAULT_LANGUAGE];
